import React from 'react';

import API from '../../images/api.svg';

export const APILogo = () => {
  return <img height="18" src={API} alt="API logo" />;
};
